import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';
import { APP_ROUTES } from '../../advisor/routes';
import { ApplicationConfigService } from '../services/config.service';

export function getClientSettings(): AuthConfig {
  const portalUrl = window.location.protocol + '//' + window.location.host;
  return {
    issuer: environment.production ? ApplicationConfigService.config.oktaAuthUrl : 'http://localhost:44353',
    redirectUri: environment.production ? portalUrl : 'http://localhost:4200',
    clientId: ApplicationConfigService.config.oktaClientId,
    responseType: 'code',
    scope: 'openid profile',
    showDebugInformation: environment.production,
    postLogoutRedirectUri: portalUrl + '/' + APP_ROUTES.signoutRedirect,
    sessionChecksEnabled: true,
  };
}
